import css from 'styled-jsx/css';
import { colors } from 'components/styles/variables';

export default css`
  .outer-container {
    display: flex;
    align-items: center;
  }

  .badge {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 20px;
    border-radius: 4px;
    padding: 2px 6px;
    color: white;
    font-size: 12px;
    font-weight: 600;
    letter-spacing: 0.2px;
    line-height: 16px;
    text-transform: uppercase;
  }

  .badge:first-child {
    margin-right: 8px;
  }

  .badge.contacted,
  .badge.viewed {
    background-color: black;
  }

  .badge.hot_car {
    background-color: ${colors.ALR1};
  }

  .badge.price_drop {
    background-color: ${colors.ALG1};
  }

  .badge.fresh {
    background-color: ${colors.ALB1};
  }
`;
